import { EnpsElevenPointScaleRating } from './types';

export const isValidENPSRating = (
  rating: any
): rating is EnpsElevenPointScaleRating => {
  const validRatings: EnpsElevenPointScaleRating[] = [
    -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
  ];
  return validRatings.includes(rating) && typeof rating === 'number';
};
